import React, { useContext, useState } from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { Box, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { Navigation, Pagination } from 'swiper/modules';
import type { Swiper as SwiperCore } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import UpcomingSubjectPapersHeader from './UpcomingSubjectPapersHeader';
import UpcomingSubjectPapersCard from './UpcomingSubjectPapersCard';
import { UpcomingSubjectPaperContext } from '../../../pages/subject/upcomingSubjectPapersBoard';

const useStyles = makeStyles()((theme) =>
({
  container: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(3),
    background: theme.color.background.bgNavigation,
    borderRadius: theme.spacing(2),
    minHeight: theme.spacing(40),
  },
  content: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
  },
  swiperSlide: {
    paddingRight: theme.spacing(0),
    paddingBottom: theme.spacing(6),
  },
  noAnnouncementMessage: {
    display: 'flex',
    height: theme.spacing(15),
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.color.text.textAccent,
  },
}));

const DesktopUpcomingSubjectPapers = () => {
  const upcomingSubjectPapers = useContext(UpcomingSubjectPaperContext);
  const { classes } = useStyles();
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isEndPage, setIsEndPage] = useState(false);
  const { t } = useTranslation();

  const handleSlideChange = (swiper: SwiperCore) => {
    if (swiper.realIndex === 0) {
      setIsFirstPage(true);
    } else {
      setIsFirstPage(false);
    }
    if (swiper.realIndex === swiper.slides.length - 3) {
      setIsEndPage(true);
    } else {
      setIsEndPage(false);
    }
  };

  return (
    <Box className={classes.container}>
      <UpcomingSubjectPapersHeader
        totalUpcomingSubjectPapers={upcomingSubjectPapers.length}
        isDesktopView
        isFirstPage={isFirstPage}
        isEndPage={isEndPage}
      />
      {upcomingSubjectPapers.length !== 0 ? (
        <Box>
          <Swiper
            modules={[Navigation, Pagination]}
            navigation={{
              nextEl: '.nextButton',
              prevEl: '.prevButton',
            }}
            onSlideChange={handleSlideChange}
            slidesPerView={3}
            slidesPerGroup={3}
            spaceBetween={15}
          >
            {upcomingSubjectPapers.map((upcomingSubjectPaperDetail) => (
              <SwiperSlide
                key={`${upcomingSubjectPaperDetail.subjectPaper}-${upcomingSubjectPaperDetail.dateOfPaper}`}
                className={classes.swiperSlide}
              >
                <UpcomingSubjectPapersCard {...upcomingSubjectPaperDetail} />
              </SwiperSlide>
            ))}
          </Swiper>
          <Typography variant="caption">
            {t('admin->>UpcomingSubjectPapers.UpcomingSubjectNotes')}
          </Typography>
        </Box>
      ) : (
        <Typography className={classes.noAnnouncementMessage} variant="h3">
          {t('admin->>UpcomingSubjectPapers.NoUpcomingSubjectMessage')}
        </Typography>
      )}
    </Box>
  );
};

export default DesktopUpcomingSubjectPapers;
